export default __webpack_public_path__ + "static/media/MINUJUSTH_strategic_assesment.3f80c4a8.jpg";